import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const Nav = (props) => {

    const navigate = useNavigate();

    const scrollTo2 = (id) =>{

        setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 1000);

    }

    const scrollTo = (id) => {

        if(props.target === "home"){
            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
            }, 0);
        }
        else{

            navigate("/");

            scrollTo2(id);
            
        }


      };



    return (
        <div className='w-full bg-[#8A8A89] text-white flex justify-between items-center relative'>

            <img onClick={() => navigate("/nos-promos")} src='/assets/images/promos.png' className='w-[50vw] md:w-[16vw] cursor-pointer' alt='electro titan promos' />


            <ul className="md:flex hidden gap-10 text-base">

                {/* <li onClick={() => scrollTo("home")} className='font-Montserrat font-regular cursor-pointer hover:text-[#FFAA00]'>Accueil</li> */}
                <li onClick={() => scrollTo("promos")} className='font-Montserrat font-regular cursor-pointer hover:text-[#FFAA00]'>Nos Promos</li>
                <li onClick={() => scrollTo("category")} className='font-Montserrat font-regular cursor-pointer hover:text-[#FFAA00]'>Nos Catégories</li>
                <li onClick={() => scrollTo("nos-produits")}  className='font-Montserrat font-regular cursor-pointer hover:text-[#FFAA00]'>Nos Produits</li>
                <li onClick={() => scrollTo("about")} className='font-Montserrat font-regular cursor-pointer hover:text-[#FFAA00]'>À Propos</li>

            </ul>


            <Link to={"/adresse"}><img src='/assets/images/adresse.png' className='w-[50vw] md:w-[16vw]' alt='electro titan adresse' /></Link>


        </div>
    )
}

export default Nav